import axios from "axios";
import { Space3DURL } from "../utility/initApp.js";

class Api3DxService {
  constructor(path = "", option = {}) {
    this.path = path;
    this.option = option;
  }

  async get() {
    let csrf = "";
    try {
      csrf = await getCSRF();
    } catch (e) {
      // Fallback if CSRF fails
    }
    return this.execute("GET", this.path, csrf, this.option);
  }

  async post(data) {
    const csrf = await getCSRF();
    return this.execute("POST", this.path, csrf, this.option, data);
  }

  async update(data) {
    const csrf = await getCSRF();
    return this.execute("PUT", this.path, csrf, this.option, data);
  }

  async deleteWithBody(data) {
    const csrf = await getCSRF();
    return this.execute("DELETE", this.path, csrf, this.option, data);
  }

  async execute(method, path, csrf, option = {}, data = null) {
    const client = axios.create({
      baseURL: Space3DURL,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-requested-with": "csrf protection",
        ENO_CSRF_TOKEN: csrf,
        ...(option.headers || {}),
      },
      withCredentials: true,
    });

    try {
      const response = await client({
        method,
        url: path,
        data,
      });
      return response;
    } catch (err) {
      throw err;
    }
  }
}

// Global cache for CSRF token
let cachedCSRF = {
  token: null,
  timestamp: 0
};

async function getCSRF() {
  const now = Date.now();
  // Cache the token for 10 minutes
  if (cachedCSRF.token && (now - cachedCSRF.timestamp < 10 * 60 * 1000)) {
    return cachedCSRF.token;
  }

  try {
    const api = new Api3DxService("/resources/v1/application/CSRF", {});

    const response = await api.execute(
      "GET",
      "/resources/v1/application/CSRF",
      null,
      {}
    );

    const token = response?.data?.csrf?.value;
    if (token) {
      cachedCSRF.token = token;
      cachedCSRF.timestamp = now;
    }
    return token;
  } catch (e) {
    throw new Error(e.message);
  }
}

export default Api3DxService;
